import { Input } from "antd";
import ContentHeader from "../../../components/shared/ContentHeader";
import { useTenantCustomers } from "../../../hooks/useTenantCustomers";
import CustomersTable from "./Table";
import { SearchOutlined } from "@ant-design/icons";
import { useMemo, useState } from "react";

const Customers = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { customers, loading } = useTenantCustomers();

  const filteredCustomers = useMemo(
    () =>
      customers.filter((customer) => {
        const search = searchTerm.toLowerCase();

        return (
          `${customer.first_name} ${customer.last_name}`
            .toLowerCase()
            .includes(search) ||
          customer.email?.toLowerCase().includes(search) ||
          `${customer?.phone_country_code} ${customer?.phone}`
            .toLowerCase()
            .includes(search) ||
          customer?.conversation_count?.toString().includes(search)
        );
      }),
    [customers, searchTerm],
  );

  return (
    <div>
      <ContentHeader title={"Customers"}>
        <Input
          placeholder="Search branches..."
          prefix={<SearchOutlined />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </ContentHeader>
      <CustomersTable customers={filteredCustomers} loading={loading} />
    </div>
  );
};

export default Customers;
